import React from 'react';
import '../styles/PricingCard.css';
import { formatterLong } from '../styles/GlobalStyles';
import { Button } from './';

function PricingCard(props) {
    const item = props.item;
    const cta = props.cta;
    const disabled = props.disabled;
    return (
        <div className="pricing-card-outer-container">
            <div className="pricing-card-inner-container">
                <div className="pricing-card-title-container">
                    <span className="heading-large-regular colour-primary block-text text-align-center">
                        {item.icon}
                    </span>
                    <h2 className="body-regular colour-primary text-align-center">
                        {item.label}
                    </h2>
                    <span className="heading-large-bold colour-primary text-align-center">
                        {formatterLong.format(item.price).replace(".00", "")}
                        <span className="body-regular colour-secondary">
                            /month
                        </span>
                    </span>
                </div>
                <span className="heading-small-regular colour-primary text-align-center">
                    {item.credits} reports
                </span>
                <span className="body-regular colour-secondary block-text text-align-center">
                    {item.description}
                </span>
                <div className="pricing-card-cta-container">
                    <Button
                        buttonType={item.button}
                        size="large"
                        text={item.cta}
                        cta={cta}
                        disabled={disabled}
                        leftIcon={null}
                        leftIconClass=""
                        rightIcon={null}
                        rightIconClass=""
                        alt=""
                        standardIcon={false}
                        badge={false}
                        badgeVal={null}
                        badgeBG={null}
                        buttonRef={null}
                        spinner={false}
                    />
                </div>
            </div>
        </div>
    )
};

export default PricingCard;